import './Home.css';

export default function Home() {
  return (
    <div className="home">
      <div className="home-page">
        <header className="home-header">
          <div className="home-logo-text">4mal</div>
          <div className="home-subtitle">
            Онлайн‑сервис для учета, покупки и продажи сельхозживотных
          </div>

          <nav className="home-nav">
            <a href="#user-agreement">Пользовательское соглашение</a>
            <a href="#privacy-policy">Политика конфиденциальности</a>
            <a href="#about">О компании</a>
          </nav>
        </header>

        <main className="home-main">
          <section id="user-agreement" className="home-section">
            <h2>Пользовательское соглашение</h2>
            <p>
              Используя приложение 4mal, вы подтверждаете, что ознакомились с
              условиями использования сервиса и принимаете их. Сервис
              предназначен для учета, покупки и продажи
              сельскохозяйственных животных без посредников.
            </p>
            <p className="home-section-note">
              <a href="/links/user_agreement_rules_of_use_of_the_application.html">
                Открыть полную версию пользовательского соглашения
              </a>
            </p>
          </section>

          <section id="privacy-policy" className="home-section">
            <h2>Политика конфиденциальности</h2>
            <p>
              Мы обрабатываем персональные данные пользователей в объеме,
              необходимом для работы сервиса, аналитики и поддержки. Данные не
              передаются третьим лицам, за исключением случаев, предусмотренных
              законом.
            </p>
            <p className="home-section-note">
              <a href="/links/terms_and_privacy.html">
                Открыть полную политику конфиденциальности
              </a>
            </p>
          </section>

          <section id="about" className="home-section">
            <h2>О компании</h2>
            <p>
              4mal.kz — сервис для фермеров и владельцев хозяйств по всей
              стране. Наша цель — сделать учет, покупку и продажу животных
              простыми, понятными и доступными с телефона или компьютера,
              онлайн и офлайн.
            </p>
            <p className="home-section-note">
              <a href="/links/newserviceltd.html">
                Информация о правообладателе NEW SERVICE LTD
              </a>
            </p>
          </section>
        </main>

        <footer className="home-footer">
          <div>© NEW SERVICE LTD</div>
          <div className="home-footer-links">
            <a href="/links/user_agreement_rules_of_use_of_the_application.html">
              Полное соглашение
            </a>
            <a href="/links/terms_and_privacy.html">
              Полная политика конфиденциальности
            </a>
            <a href="/links/newserviceltd.html">Информация о компании</a>
          </div>
        </footer>
      </div>
    </div>
  );
}
